var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexFade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 72,
    viewBox: "0 0 63 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1336 0.013916L62.2672 18.0104V54.0035L31.1336 72L0 54.0035V18.0104L31.1336 0.013916Z",
    fill: "#0E1D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexFade);
export default __webpack_public_path__ + "static/media/hexFade.587c140dc3d57ea88d8c329ca1a89997.svg";
export { ForwardRef as ReactComponent };